/* eslint-disable no-nested-ternary */
import styled from "styled-components";

type Positions = "flex-start" | "flex-end" | "center" | "space-between";

interface IContainerFlex {
  container?: boolean;
  height?: number;
  width?: number;
  maxWidth?: number;
  maxHeight?: number;
  center?: boolean;
  end?: boolean;
  align?: Positions;
  horizontal?: boolean;
  space?: boolean;
  spaceAround?: boolean;
  padding?: number;
  marginTop?: number;
  marginRight?: number;
  marginBottom?: number;
  marginLeft?: number;
  row?: boolean;
  flex?: number | string;
  flexFlow?: "wrap" | "nowrap" | "column" | "column-reverse" | "row" | "none";
  wrap?: boolean;
  color?: string;
  opacity?: string;
  border?: string;
  borderRadius?: number;
  justifyContent?: string;
  scroll?: boolean;
  disabled?: boolean;
  gap?: string;
}

const ContainerFlex = styled.div<IContainerFlex>`
  height: ${(p) => (p.height ? `${p.height}%` : p.container ? "100%" : "auto")};
  width: ${(p) => (p.width ? `${p.width}%` : "-webkit-fill-available")};
  max-width: ${(p) => (p.maxWidth ? `${p.maxWidth}%` : "none")};
  max-height: ${(p) => (p.maxHeight ? `${p.maxHeight}px` : "none")};
  background-color: ${(p) => (p.color ? `${p.color}` : "transparent")};
  opacity: ${(p) => (p.opacity ? `${p.opacity}` : "none")};
  gap: ${(p) => (p.gap ? `${p.gap}` : "0px")};

  border: ${(p) => (p.border ? `${p.border}` : "none")};
  border-radius: ${(p) => (p.borderRadius ? `${p.borderRadius}px` : "none")};

  flex-wrap: ${(p) => (p.wrap ? "wrap" : "nowrap")};
  -webkit-flex-wrap: ${(p) => (p.wrap ? "wrap" : "nowrap")};

  margin-top: ${(p) => (p.marginTop ? `${p.marginTop}px` : "0px")};
  margin-bottom: ${(p) => (p.marginBottom ? `${p.marginBottom}px` : "0px")};
  margin-left: ${(p) => (p.marginLeft ? `${p.marginLeft}px` : "0px")};
  margin-right: ${(p) => (p.marginRight ? `${p.marginRight}px` : "0px")};

  display: ${(p) => (p.disabled ? "none" : "flex")};
  flex: ${(p) => (p.flex ? p.flex : "1")};
  flex-direction: ${(p) => (p.row ? "row" : "column")};
  flex-flow: ${(p) => (p.flexFlow ? p.flexFlow : "none")};

  align-items: ${(p) => (p.align ? p.align : p.center ? "center" : "none")};
  overflow: ${(p) => (p.scroll ? "scroll" : "none")};
  overflow-x: ${(p) => (p.scroll ? "hidden" : "none")};

  padding: ${(p) => (p.padding ? `${p.padding}px` : "0px")};
  position: relative;
  justify-content: ${(p) =>
    // eslint-disable-next-line no-nested-ternary
    p.space
      ? "space-between"
      : // eslint-disable-next-line no-nested-ternary
      p.center && p.horizontal
      ? "center"
      : p.end
      ? "flex-end"
      : p.spaceAround
      ? "space-around"
      : "none"};
`;

export const PrintableBodyWrapper = styled.div`
  @page {
    margin: 0;
  }

  font-family: 'Source Code Pro', monospace;
  padding: 4mm 2mm;
  box-sizing: border-box;
  color: #000;

  @media print {
    background: transparent !important;
    color: #000 !important;
    text-shadow: none !important;
    filter: none !important;
    -ms-filter: none !important;
    overflow: hidden;
    width: 80mm;
    padding: 4mm 6mm;
  }
`;


export default ContainerFlex;
